import { Button, Col, Row, Select, Form, DatePicker, Switch, Table, Tooltip, Alert } from "antd";
import { useTranslation } from "react-i18next";
import { AccountAsignationData, EditAccountAsignationData, KeyValue } from "../../../models/AccountAsignationData";
import { DeleteOutlined, EditOutlined, HomeOutlined } from "@ant-design/icons";
import './AccountAsignationListComponent.scss';
import moment from "moment";
import { useCallback, useEffect, useRef, useState } from "react";
import { GenericModal } from "../../common/Modal/GenericModal";
import { fetchContractById, GetConfigurationAccounts } from "../../../api/repositoryEP";
import debounce from "lodash/debounce";
import { GenericKeyValuePair } from "../../../models/CustomField";
import HotelInfo from "../../../models/HotelInfo";
import { Contract } from "../../../models/Contract";


interface AccountAsignationListComponent2Props {
    configuration: AccountAsignationData;

    setEditDrawerVisible: (isVisible: boolean) => void;
    setSelectedConfiguration: (aad: AccountAsignationData | null) => void; // Nueva prop


    contracts: Contract[],
    markets: KeyValue[],

    edit: (data: EditAccountAsignationData) => void;
    delete: (id: string) => void;


}

const AccountAsignationElement = (props: AccountAsignationListComponent2Props): JSX.Element => {
    const { t } = useTranslation();
    const [form] = Form.useForm();

    const [deleting, setIsDeleting] = useState<boolean>(false);
    const [saving, setIsSaving] = useState<boolean>(false);
    const [isChangingStatus, setIsChangingStatus] = useState<boolean>(false);
    const [isAvailableChangeStatus, setIsAvailableChangeStatus] = useState<boolean>(true);
    const [contractHasChanged, setContractHasChanged] = useState<boolean>(false);
    const [hotelsAffected, setHotelsAffected] = useState<HotelInfo[]>(props.configuration.hotelsAffected);
    const [showHotelsTable, setShowHotelsTable] = useState<boolean>(false);
    const [accountSearchValue, setAccountSearchValue] = useState<string>('');



    useEffect(() => {
        if (props.configuration.affectedAccounts <= 0) {
            //  setIsAvailableChangeStatus(false)
        }
    }, []);



    const onDeleteConfiguration = async (id: string) => {
        setIsDeleting(true);
        try {
            await props.delete(id); // Llama a la función de eliminación

        } finally {
            setIsDeleting(false);
        }
    };

    const handleSave = async (accountAsignation: AccountAsignationData, values: any) => {
        setIsSaving(true)


        var accountsData = values.accounts.map((accountId: string) => {
            var accountType = selectedAccountValues.find((accountValue) => accountValue.id === accountId)?.accountType;
            var data: GenericKeyValuePair = {
                key: accountId,
                value: accountType
            }

            return data;
        })

        const updatedAccount: EditAccountAsignationData = {
            id: accountAsignation.id,
            name: null,
            status: null,
            applyFrom: values.from ? values.from.format("YYYY-MM-DD") : null,
            applyTo: values.to ? values.to.format("YYYY-MM-DD") : null,
            marketsSelected: values.markets, // Ya contiene los keys seleccionados
            accountsSelected: accountsData, // Ya contiene los keys seleccionados
            contractSelected: values.contract, // Directamente el key seleccionado
        };



        try {
            await props.edit(updatedAccount);

        } finally {
            // Desactiva el estado de carga para este ID
            setIsSaving(false)
            setIsAvailableChangeStatus(true)
        }
    };


    const [modalVisible, setModalVisible] = useState(false);
    const [deleteModalVisible, setDeleteModalVisible] = useState(false);
    const [isLoadingModal, setIsLoadingModal] = useState(false);
    const pendingSwitchRef = useRef<{
        id: string;
        isActive: boolean;
    } | null>(null);

    const handleSwitchClick = (currentChecked: boolean, accountAsignation: AccountAsignationData) => {

        const pendingState = { id: accountAsignation.id, isActive: !currentChecked };
        pendingSwitchRef.current = pendingState;
        if (currentChecked) {
            setModalVisible(true);
        } else {
            confirmSwitchChange();
        }

    };


    const confirmSwitchChange = async () => {

        if (pendingSwitchRef.current) {
            const { id, isActive } = pendingSwitchRef.current;

            // Actualiza el estado en el servidor o realiza cualquier acción
            const updatedAccount: EditAccountAsignationData = {
                id,
                name: null,
                status: isActive ? 'active' : 'inactive',
                applyFrom: null,
                applyTo: null,
                marketsSelected: null,
                accountsSelected: null,

                contractSelected: null,
            };
            setIsLoadingModal(true);
            try {
                setIsChangingStatus(true)
                await props.edit(updatedAccount); // Esperar la operación
            } finally {
                setIsChangingStatus(false)
                setIsLoadingModal(false);
                pendingSwitchRef.current = null;
                setModalVisible(false);
            }
        }
    };


    const cancelSwitchChange = () => {
        pendingSwitchRef.current = null; // Limpiar referencia
        setModalVisible(false);
    };



    const [loading, setLoading] = useState<boolean>(false);
    const [totalMatches, setTotalMatches] = useState<number>(0);
    const [options, setOptions] = useState<any[]>([]);
    const [selectedAccountValues, setSelectedAccountValues] = useState(
        props.configuration.accountsSelected.map((account) => ({
            id: account.id,
            name: account.name,
            accountType: account.accountType,
            country: account.country,
        }))
    );


    const [selectedCountries, setSelectedCountries] = useState<string[]>(props.configuration.marketsSelected); // Cantidad de opciones seleccionadas

    const handleSearch = useCallback(
        debounce(async (name) => {

            if (name) {
                setLoading(true);
                try {
                    const response = await GetConfigurationAccounts(selectedCountries, name);
                    if (response?.type === 1) {
                        // Formatear las opciones y excluir seleccionados
                        const formattedOptions = response.data.accounts
                            .map((account: any) => ({
                                label: <div className="account-info"><label>{account.name} </label><small>{account.actualContractName}</small><small>{account.address} ({account.country})</small></div>,
                                value: account.id,
                                name: account.name,
                                address: account.address,
                                accountType: account.accountType,
                                actualContractName: account.actualContractName,
                                country: account.country
                            }))
                            .filter((option: any) => !selectedAccountValues.some(sv => sv.id === option.value));

                        // Actualizar las opciones sin acumular duplicados
                        setOptions(formattedOptions);
                        setTotalMatches(formattedOptions.length);
                    }
                } finally {
                    setLoading(false);
                }
            } else {
                setOptions([]); // Limpia si no hay búsqueda
                setTotalMatches(0);
            }
        }, 300),
        [selectedAccountValues, selectedCountries]
    );




    const handleAddAccount = (value: string) => {
        const option = options?.find(opt => opt.value === value);
        if (!option) return;

        const newAccount = {
            id: option.value,
            name: option.name ?? option.value,
            country: option.country ?? '',
            accountType: option.accountType ?? '',
        };

        const combined = [
            ...(selectedAccountValues || []),
            newAccount,
        ].filter((v, i, self) => self.findIndex(x => x.id === v.id) === i);

        setSelectedAccountValues(combined);
        form.setFieldValue('accounts', combined.map(a => a.id));
        setAccountSearchValue('');
        setOptions([]);
        setTotalMatches(0);
    };

    const handleRemoveAccount = (id: string) => {
        const updated = (selectedAccountValues || []).filter(a => a.id !== id);
        setSelectedAccountValues(updated);
        form.setFieldValue('accounts', updated.map(a => a.id));
    };

    useEffect(() => {
        // Sincronizar el campo del formulario con los IDs de las cuentas seleccionadas
        form.setFieldValue(
            'accounts',
            selectedAccountValues.map(account => account.id)
        );
    }, [selectedAccountValues, form]);



    useEffect(() => {
        return () => handleSearch.cancel();
    }, [handleSearch]);

    useEffect(() => { }, [selectedCountries]);


    const handleSelectCountry = (value: string) => {
        // Agregar el país a la lista de países seleccionados
        setSelectedCountries((prevSelected) => [...prevSelected, value]);

        // Filtrar las cuentas seleccionadas que correspondan al país actual o a cualquier país en selectedCountries
        setSelectedAccountValues((prevSelected) =>
            prevSelected.filter(
                (account) =>
                    account.country === value || selectedCountries.includes(account.country)
            )
        );
        setOptions([]);
        setTotalMatches(0);
    };

    const handleDeselectCountry = (value: string) => {
        // 1. Eliminar el país de la lista de países seleccionados
        setSelectedCountries((prevSelected) =>
            prevSelected.filter((country) => country !== value)
        );

        // 2. Actualizar las cuentas seleccionadas para eliminar las asociadas al país deseleccionado
        setSelectedAccountValues((prevSelected) =>
            prevSelected.filter((account) =>
                selectedCountries.filter((country) => country !== value).includes(account.country)
            )
        );
        setOptions([]);
        setTotalMatches(0);

    };


    useEffect(() => {
        if (isChangingStatus) {
            setIsAvailableChangeStatus(isChangingStatus)
        }
    }, [isChangingStatus])

    const onChangeContract = (value: string) => {
        if (value !== props.configuration.contractSelected) {
            setContractHasChanged(true);
            fetchContractById(value).then((response) => {
                if (response?.type == 1) {
                    setHotelsAffected(response.data.hotelsAffected)
                }
            })

        } else {
            setContractHasChanged(false)
        }
    };

    const countriesHasChanged = (): boolean => {
        return selectedCountries.length !== props.configuration.marketsSelected.length ||
            !selectedCountries.slice().sort().every((value, index) => value === props.configuration.marketsSelected.slice().sort()[index]);
    };

    const accountsHasChanged = (): boolean => {
        return selectedAccountValues.length !== props.configuration.accountsSelected.length ||
            !selectedAccountValues.every(selected =>
                props.configuration.accountsSelected.some(config =>
                    selected.id === config.id && selected.accountType === config.accountType
                )
            );
    };


    const switchBlockReasons = {
        notAvailable: !isAvailableChangeStatus,
        saving,
        contractHasChanged,
        countriesChanged: countriesHasChanged(),
        accountsChanged: accountsHasChanged(),
        isChangingStatus,
        //    noAffectedAccounts: props.configuration.affectedAccounts <= 0,
    };

    const isSwitchDisabled = Object.values(switchBlockReasons).some(Boolean);

  /*  useEffect(() => {
        if (isSwitchDisabled) {
            console.log("Switch bloqueado para:", props.configuration.name);
            console.table(switchBlockReasons);
        }
    }, [isSwitchDisabled]); */



    return (
        <div className="account-assignation-component">
            <Row className="commissions-configuration-list">
                <Col xs={24} md={24} className="commission-container" >
                    <Form form={form}
                        layout="vertical"
                        initialValues={{
                            isActive: props.configuration.status == 'active',
                            markets: props.configuration.marketsSelected.filter((selectedMarket) =>
                                props.markets.some((market) => market.key === selectedMarket)
                            ),
                            accounts: props.configuration.accountsSelected.map((account) => account.id), // Preselección de valores
                            from: props.configuration.applyFrom ? moment(props.configuration.applyFrom) : null,
                            to: props.configuration.applyTo ? moment(props.configuration.applyTo) : null,
                            contract: props.configuration.contractSelected,
                        }}
                        onFinish={(values) => {
                            handleSave(props.configuration, values);
                        }} // Manejar guardar
                    >

                        <Row gutter={[10, 0]}>
                            <Col xs={24} md={24} className="commission-title">
                                <div className="title-container">
                                    <h3>{props.configuration.name}</h3>

                                    <EditOutlined
                                        className="edit-icon-style"
                                        onClick={() => {
                                            props.setSelectedConfiguration(props.configuration); // Selecciona la configuración actual
                                            props.setEditDrawerVisible(true); // Abre el drawer de edición
                                        }}
                                    />
                                </div>

                                <Form.Item name="isActive" className="switch-container">
                                    <Switch
                                        className="app-switch"
                                        checked={props.configuration.status === 'active'}
                                        disabled={isSwitchDisabled}
                                        onClick={() =>
                                            handleSwitchClick(props.configuration.status == 'active', props.configuration)
                                        }
                                    />
                                </Form.Item>
                            </Col>

                        </Row>


                        <Row gutter={[10, 0]}>
                            <Col xs={24} md={12}>
                                <Form.Item name="contract" label={t("pages.account-asignation.contract")}>
                                    <Select
                                        onChange={onChangeContract}
                                        className="app-select"
                                        options={props.contracts
                                            .filter((contract) => !contract.isBase)
                                            .map((contract) => ({
                                                label: contract.name,
                                                value: contract.id,
                                            }))}
                                    />



                                </Form.Item>
                            </Col>
                            <Col xs={12} md={12}></Col>

                            <Col xs={24} md={12}>
                                <Form.Item name="markets" label={t("pages.account-asignation.market")}>
                                    <Select
                                        className="app-select"
                                        mode="multiple"
                                        value={selectedCountries}
                                        onSelect={handleSelectCountry}
                                        onDeselect={handleDeselectCountry}
                                        options={props.markets.map((market) => ({
                                            label: market.value,
                                            value: market.key,
                                        }))
                                        }
                                        showSearch
                                        filterOption={(input, option) =>
                                            (option?.label as string).toLowerCase().includes(input.toLowerCase())
                                        }
                                    />
                                </Form.Item>
                            </Col>

            <Col xs={24} md={12}>
                                <Form.Item name="accounts" style={{ display: 'none' }}>
                                    <Select mode="multiple" />
                                </Form.Item>
                                <div className="accounts-search-label">
                                    {t("pages.account-asignation.accounts")} ({selectedAccountValues.length})
                                </div>
                                <Select
                                    className="app-select"
                                    showSearch
                                    loading={loading}
                                    filterOption={false}
                                    value={accountSearchValue || undefined}
                                    options={options}
                                    onSearch={(val) => { setAccountSearchValue(val); handleSearch(val); }}
                                    onSelect={(value: any) => value && handleAddAccount(value)}
                                    placeholder={t("pages.account-asignation.accounts") || 'Buscar cuenta...'}
                                    notFoundContent={
                                        accountSearchValue
                                            ? (loading ? null : <span style={{ fontStyle: 'italic', color: '#999' }}>{t('pages.payments-configuration.no-accounts-found')}</span>)
                                            : <span style={{ fontStyle: 'italic', color: '#999' }}>{t('pages.payments-configuration.type-to-search-accounts')}</span>
                                    }
                                    style={{ width: '100%', marginBottom: 8 }}
                                />
                                {selectedAccountValues.length > 0 && (
                                    <Table
                                        className="accounts-table"
                                        dataSource={selectedAccountValues}
                                        rowKey="id"
                                        size="small"
                                        showHeader={false}
                                        pagination={{ pageSize: 5, hideOnSinglePage: true, size: 'small' }}
                                        columns={[
                                            {
                                                dataIndex: 'name',
                                                render: (name: string) => <span>{name}</span>,
                                            },
                                            {
                                                width: 40,
                                                render: (_: any, record: any) => (
                                                    <Tooltip title={t('button.delete')}>
                                                        <Button
                                                            type="text"
                                                            size="small"
                                                            icon={<DeleteOutlined />}
                                                            onClick={() => handleRemoveAccount(record.id)}
                                                            danger
                                                        />
                                                    </Tooltip>
                                                ),
                                            },
                                        ]}
                                    />
                                )}
                            </Col>


                            <Col xs={24} md={12}>
                                <Form.Item

                                    name="from"
                                    label={t("pages.account-asignation.from")}
                                >
                                    <DatePicker className="app-input" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={12}>
                                <Form.Item
                                    name="to"
                                    label={t("pages.account-asignation.to")}
                                    rules={[
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                const passwordFieldValue = getFieldValue('from');
                                                if (passwordFieldValue && value && value.isBefore(passwordFieldValue)) {
                                                    return Promise.reject(t("pages.account-asignation.error-date-validation"));
                                                }
                                                return Promise.resolve();
                                            }
                                        }),
                                    ]}
                                >
                                    <DatePicker className="app-input" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24}>
                                <Alert
                                    style={{ margin: "0px 0px 20px 0px" }}
                                    message={t("pages.account-asignation.date-warning")}
                                    type="warning"
                                    showIcon
                                    closable />
                            </Col>

                            <Col xs={24} md={24} className="feedback-container">
                                <h3 className="feedback-title-style">{t("pages.account-asignation.feedback")}</h3>
                                <div className="app-text xs">
                                    <strong>{t("pages.account-asignation.accounts-affected")} </strong>
                                    {(contractHasChanged
                                        ||
                                        countriesHasChanged()
                                        ||
                                        accountsHasChanged()
                                        ) ? t("pages.account-asignation.to-determinate") : props.configuration.affectedAccounts}
                                </div>
                                {hotelsAffected.length > 0 && (
                                    <div className="app-text xs" style={{ marginTop: 6 }}>
                                        <strong>{t("pages.account-asignation.hotels-affected")}:{" "}</strong>
                                        <span className="hotels-count">{hotelsAffected.length}</span>
                                        <span
                                            className="hotels-toggle-link"
                                            onClick={() => setShowHotelsTable(v => !v)}
                                        >
                                            {showHotelsTable ? t("button.hide") : t("button.show-more")}
                                        </span>
                                        {showHotelsTable && (
                                            <Table
                                                className="hotels-table"
                                                dataSource={hotelsAffected}
                                                rowKey="id"
                                                size="small"
                                                showHeader={false}
                                                style={{ marginTop: 8 }}
                                                pagination={{ pageSize: 5, hideOnSinglePage: true, size: 'small' }}
                                                columns={[
                                                    {
                                                        dataIndex: 'name',
                                                        render: (name: string) => (
                                                            <span className="hotel-table-row">
                                                                <HomeOutlined className="hotel-icon" />
                                                                {name}
                                                            </span>
                                                        ),
                                                    },
                                                ]}
                                            />
                                        )}
                                    </div>
                                )}


                            </Col>

                            <Col xs={24} md={24} className="buttons-container">

                                <Button type="primary"
                                    loading={saving}
                                    disabled={deleting || saving || (selectedCountries.length <= 0 && selectedAccountValues.length <= 0)}
                                    htmlType="submit"
                                    className="app-button">
                                    {t("button.save")}
                                </Button>
                                <Button
                                    type="default"
                                    className="app-button danger"
                                    disabled={deleting || saving}
                                    loading={deleting} // Muestra el estado de carga específico
                                    onClick={() => setDeleteModalVisible(true)}
                                >
                                    {t("button.delete")}
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>


            <GenericModal
                isLoading={isLoadingModal}
                title={t("pages.account-asignation.confirm-status-title")}
                closable
                content={<div>{t("pages.account-asignation.confirm-message")}</div>}
                visible={modalVisible}
                onOk={confirmSwitchChange}
                onCancel={cancelSwitchChange}
            />

            <GenericModal
                title={t("pages.account-asignation.confirm-delete-title")}
                closable
                content={<div>{t("pages.account-asignation.delete-message")}</div>}
                visible={deleteModalVisible}
                onOk={() => onDeleteConfiguration(props.configuration.id)}
                isLoading={deleting}
                onCancel={() => setDeleteModalVisible(false)}
            />
        </div >
    );
}

export default AccountAsignationElement;